<div class="m-4 columns">
  <div class="column is-half is-offset-one-quarter">
    <div class="box {$$props.class}">
      <slot />
    </div>
  </div>
</div>
